/**
 * The Leads list's URL contract. `/leads` reads these query params as its
 * initial filters, so a company, user or conference page can link "See all
 * leads" straight into a pre-filtered list.
 */
export interface LeadsUrlFilter {
  companyId?: string;
  repOid?: string;
  conferenceId?: string;
}

export const LEADS_URL_PARAMS = ['companyId', 'repOid', 'conferenceId'] as const;

export function leadsHref(filter: LeadsUrlFilter = {}): string {
  const params = new URLSearchParams();
  for (const key of LEADS_URL_PARAMS) {
    const v = filter[key];
    if (v) params.set(key, v);
  }
  const qs = params.toString();
  return qs ? `/leads?${qs}` : '/leads';
}

export function readLeadsUrlFilter(searchParams: URLSearchParams): LeadsUrlFilter {
  const out: LeadsUrlFilter = {};
  for (const key of LEADS_URL_PARAMS) {
    const v = searchParams.get(key);
    if (v) out[key] = v;
  }
  return out;
}
